import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Typography } from '@mui/material'
import {
	fetchAdminWeddingStats,
	fetchAdminVendorStats,
	fetchAdminAccountsByWeekChart,
	fetchAdminProposalValueByMonthChart,
	fetchAdminPlannedWeddingsByWeekChart,
} from '../../features/adminSlice'
import { AdminWeddingStatsCard } from './admin-components/WeddingStatsCard.jsx'
import { AdminVendorStatsCard } from './admin-components/VendorStatsCard.jsx'
import { AdminAccountsChartCard } from './admin-components/AccountsChartCard.jsx'
import { AdminProposalValueChartCard } from './admin-components/ProposalValueChartCard.jsx'
import { AdminPlannedWeddingsChartCard } from './admin-components/PlannedWeddingsChartCard.jsx'
import styles from './SuperAdminDashboard.module.scss'

export function SuperAdminDashboard() {
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(fetchAdminWeddingStats())
		dispatch(fetchAdminVendorStats())
		dispatch(fetchAdminAccountsByWeekChart())
		dispatch(fetchAdminProposalValueByMonthChart())
		dispatch(fetchAdminPlannedWeddingsByWeekChart())
	}, [dispatch])

	return (
		<div className={styles.root}>
			<div className={styles.pageHeader}>
				<Typography component="h1" className={styles.title}>
					Dashboard
				</Typography>
			</div>
			<div className={styles.pageMain}>
				<div className={styles.statsGrid}>
					<AdminWeddingStatsCard />
					<AdminVendorStatsCard />
				</div>

				<div className={styles.chartsGrid}>
					<AdminAccountsChartCard />
					<AdminProposalValueChartCard />
					<AdminPlannedWeddingsChartCard />
				</div>
			</div>
		</div>
	)
}
